import { randomId } from '@mygpt/app/utils';
import { headerToken } from '@mygpt/app/apis';
import { useState } from 'react';
import { KEY_MYGPT_COMPLETIONS } from '@mygpt/app';
import { getStorageValue } from '@mygpt/app/utils/storage';
import { safeJWTDecode } from '@mygpt/app/utils/jwt';

/**
 *
 * @param aiId Bot ID
 * @param from 用来区分聊天记录、会话来自哪个页面（防止不同页面的聊天记录冲突）
 */
export const useSessionID = (aiId?: string, from?: string) => {
  const [uuid, setUuid] = useState(() => randomId());

  const token = headerToken();
  const decoded = safeJWTDecode(token);

  // 拼接上 uuid ，确保不同用户的会话隔离
  const LOCALSTORAGE_CHAT_KEY = `${KEY_MYGPT_COMPLETIONS}_${aiId}_${decoded.sub}${from ? `_${from}` : ''}`;
  let chatSessionId;

  for (;;) {
    if (!aiId) break;
    const chatInfo = getStorageValue(LOCALSTORAGE_CHAT_KEY);
    if (!chatInfo) break;
    const info = JSON.parse(chatInfo);
    chatSessionId = info.sessionId;
    break;
  }

  const refreshId = () => {
    setUuid(randomId());
  };

  return {
    sessionId: chatSessionId || uuid,
    LOCALSTORAGE_CHAT_KEY,
    refreshId,
  };
};
